// ================ lrc-rewards.js (dynamic, Liquid-driven, dual scrollers) ================
(function () {
    'use strict';

    const M = window.Motion;           // optional Motion One
    const blast = window.emojiBlast;   // optional emoji-blast
    const wait = (ms) => new Promise(r => setTimeout(r, ms));
    const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
    const nextFrame = () => new Promise(r => requestAnimationFrame(() => r()));
    const twoFrames = async () => { await nextFrame(); await nextFrame(); };

    function decodeHtmlEntities(s) { const t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
    function formatMoneyFromCents(cents) {
        const n = Math.max(0, Math.round(Number(cents) || 0));
        if (window.Shopify && typeof Shopify.formatMoney === 'function') { try { return Shopify.formatMoney(n); } catch { } }
        return '$' + (n / 100).toFixed(2);
    }

    // ---- IMMEDIATE/POST emitter helper ----
    function emit(root, name, detail) {
        try { root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail })); } catch { }
        try {
            const H = window.LRC_RewardsHooks || {};
            if (name === 'lrc:reward-unlocking' && typeof H.onUnlocking === 'function') H.onUnlocking(detail);
            if (name === 'lrc:reward-unlocked' && typeof H.onUnlocked === 'function') H.onUnlocked(detail);
            if (name === 'lrc:reward-locking' && typeof H.onLocking === 'function') H.onLocking(detail);
            if (name === 'lrc:reward-locked' && typeof H.onLocked === 'function') H.onLocked(detail);
        } catch { }
    }

    // ---- RewardStore (per stream) ----
    const RewardStore = (() => {
        const KEYS = { subs: 'lrc_rewards_subs', one: 'lrc_rewards_one' };
        const EMPTY = { maxCelebrated: 0, lastSeen: 0 };
        const _read = (m) => {
            try {
                const raw = localStorage.getItem(KEYS[m]);
                if (!raw) return { ...EMPTY };
                const o = JSON.parse(raw);
                return { maxCelebrated: Number(o.maxCelebrated) || 0, lastSeen: Number(o.lastSeen) || 0 };
            } catch { return { ...EMPTY }; }
        };
        const _write = (m, s) => localStorage.setItem(KEYS[m], JSON.stringify({
            maxCelebrated: Math.max(0, Number(s.maxCelebrated) || 0),
            lastSeen: Math.max(0, Number(s.lastSeen) || 0)
        }));
        return {
            getState: (m) => _read(m), getMax: (m) => _read(m).maxCelebrated, getLastSeen: (m) => _read(m).lastSeen,
            setMax(m, n) { const s = _read(m); s.maxCelebrated = Math.max(0, Number(n) || 0); _write(m, s); },
            setLastSeen(m, n) { const s = _read(m); s.lastSeen = Math.max(0, Number(n) || 0); _write(m, s); },
            lowerTo(m, n) { const v = Math.max(0, Number(n) || 0); _write(m, { maxCelebrated: v, lastSeen: v }); },
            hardReset(m) { _write(m, { maxCelebrated: 0, lastSeen: 0 }); },
            hardResetAll() { _write('subs', { maxCelebrated: 0, lastSeen: 0 }); _write('one', { maxCelebrated: 0, lastSeen: 0 }); }
        };
    })();

    // ---------------- Factory (one instance per rewards root) ----------------
    window.LRC_createRewards = function LRC_createRewards(rootEl, opts = {}) {
        const ROOT = rootEl;
        if (!ROOT) return null;

        // Two dedicated scrollers
        const SCROLLERS = {
            subs: ROOT.querySelector('.lrc-rewards-scroll-subs'),
            one: ROOT.querySelector('.lrc-rewards-scroll-one-time')
        };

        // Shared arrows
        const ARROWS = ROOT.querySelector('#lrc-rewards-arrows');
        const LEFT_WRAP = ROOT.querySelector('.slide-arrow-btn-left');
        const RIGHT_WRAP = ROOT.querySelector('.slide-arrow-btn-right');
        const LEFT_BTN = LEFT_WRAP?.querySelector('button');
        const RIGHT_BTN = RIGHT_WRAP?.querySelector('button');
        const HEADING = ROOT.querySelector('.rewards-heading');

        // Helpers to read live attributes
        const getAttrInt = (name) => parseInt(ROOT.getAttribute(name) || '0', 10) || 0;
        const getModeAttr = () => (ROOT.getAttribute('data-lrc-mode') || 'subs');
        // per-instance listener registry so destroy() can unbind (prevents stacking across rebuilds)
        const __listeners = [];
        function __on(target, event, handler, opts) {
            if (!target) return;
            target.addEventListener(event, handler, opts);
            __listeners.push({ target, event, handler, opts });
        }

        // --- add near other element refs inside LRC_createRewards ---
        function setHeadingForLane(lane) {
            if (!HEADING) return;
            if (lane === 'subs') {
                HEADING.textContent = 'Subscription Rewards';
            } else if (lane === 'one') {
                HEADING.textContent = 'One-Time Rewards';
            } else {
                HEADING.textContent = 'Rewards';
            }
        }

        // Presence-driven visual lane selection
        // function getVisualLane() {
        //     const subQty = getAttrInt('data-lrc-subqty');
        //     const oneCents = getAttrInt('data-lrc-one-subtotal');
        //     if (subQty > 0) return 'subs';
        //     if (oneCents > 0) return 'one';
        //     return null;
        // }
        function getVisualLane() {
            const subQty = getAttrInt('data-lrc-subqty');
            const oneQty = getAttrInt('data-lrc-oneqty');   // NEW
            const oneSub = getAttrInt('data-lrc-one-subtotal');
            if (subQty > 0) return 'subs';
            if (oneQty > 0 || oneSub > 0) return 'one';
            return null;
        }
        function getScroller() {
            const lane = getVisualLane();
            if (lane === 'subs') return SCROLLERS.subs;
            if (lane === 'one') return SCROLLERS.one;
            return null;
        }
        function applyVisibility() {
            const lane = getVisualLane();
            if (!SCROLLERS.subs || !SCROLLERS.one) return;
            if (lane === 'subs') {
                SCROLLERS.subs.classList.remove('hidden');
                SCROLLERS.one.classList.add('hidden');
            } else if (lane === 'one') {
                SCROLLERS.subs.classList.add('hidden');
                SCROLLERS.one.classList.remove('hidden');
            } else {
                SCROLLERS.subs.classList.add('hidden');
                SCROLLERS.one.classList.add('hidden');
            }
            // <-- update heading text here
            setHeadingForLane(lane);
            updateArrows();
        }

        // Read rewards data (for the ACTIVE stream provided by Liquid)
        const rawRewards = ROOT.getAttribute('data-lrc-rewards') || '[]';
        let REWARDS = (() => { try { return JSON.parse(decodeHtmlEntities(rawRewards)) || []; } catch { return []; } })();
        let MAX_PASS = REWARDS.length;

        const PEEK = 50;
        const GAP = 16;

        // ------- state -------
        let currentPass = clamp(Number(opts.baselinePass) || 0, 0, MAX_PASS);
        let pendingId = currentPass < MAX_PASS ? currentPass + 1 : MAX_PASS + 1;
        let pendingFill = 0;
        let isRunning = false;

        const getSubsMode = () => (ROOT.getAttribute('data-lrc-subs-mode') || 'qty'); // 'qty' | 'amount'
        const getSubsSubtotalCents = () => getAttrInt('data-lrc-subs-subtotal');

        function pageDelta() {
            const SC = getScroller();
            return Math.max(120, (SC?.clientWidth || 0) - PEEK);
        }

        function updateArrows() {
            const SC = getScroller();
            if (!SC) { if (ARROWS) ARROWS.style.display = 'none'; return; }
            const overflow = SC.scrollWidth > SC.clientWidth + 8;
            if (ARROWS) ARROWS.style.display = overflow ? '' : 'none';
            if (!overflow) return;
            const eps = 2;
            const maxLeft = SC.scrollWidth - SC.clientWidth;
            const atStart = SC.scrollLeft <= eps;
            const atEnd = SC.scrollLeft >= maxLeft - eps;
            if (LEFT_WRAP) { LEFT_WRAP.style.opacity = atStart ? '0.35' : '1'; LEFT_WRAP.style.pointerEvents = atStart ? 'none' : 'auto'; }
            if (RIGHT_WRAP) { RIGHT_WRAP.style.opacity = atEnd ? '0.35' : '1'; RIGHT_WRAP.style.pointerEvents = atEnd ? 'none' : 'auto'; }
        }

        // ======================= MODAL (See More) start =======================
        // ======================= MODAL (See More) start =======================
        // make overlay a sibling (outside) of modal content
        let modalOverlayEl = null;   // full-screen, sits UNDER the card
        let modalHolderEl = null;   // fixed container that holds the card
        let modalOpen = false;
        let lastFocused = null;

        // remember which card opened the modal (so we can animate it on close)
        let modalSrcCardEl = null;

        // prevent double-closes / missed first click
        let __closingLock = false;

        function lockBodyScroll(lock) {
            if (lock) {
                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
            } else {
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
            }
        }

        // Animate the source card's progress bar from 0% to its current/desired value
        async function animateCardProgressFromZero(srcCardEl) {
            if (!srcCardEl || !document.body.contains(srcCardEl)) return;

            const wrap = srcCardEl.closest?.('[data-reward-card]') || null;
            const bar = (wrap || srcCardEl).querySelector?.('[data-progress]') || null;
            if (!bar) return;

            let targetPct = 0;
            let color = '#ffcd8f';

            const idNum = Number(wrap?.dataset?.id || 0);
            const unlocked = (wrap?.dataset?.state === 'UNLOCKED') || (idNum && idNum <= (Number(currentPass) || 0));

            if (unlocked) {
                targetPct = 100;
                color = '#66cdd9';
            } else {
                const inline = parseFloat(String(bar.style.width || '').replace('%', ''));
                if (Number.isFinite(inline) && inline > 0) {
                    targetPct = Math.max(0, Math.min(99, inline));
                } else {
                    targetPct = Math.max(0, Math.min(99, Number(pendingPctForPass(currentPass)) || 0));
                }
                color = '#ffcd8f';
            }

            try { bar.getAnimations?.().forEach(a => { if (a instanceof CSSAnimation) return; a.cancel(); }); } catch { }

            // start at zero, then grow to target
            bar.style.backgroundColor = unlocked ? 'var(--lrc-progress-unlocked, #66cdd9)' : 'var(--lrc-progress-pending, #ffcd8f)';
            bar.style.width = '0%';

            const duration = unlocked ? 0.2 : 0.15;
            const easing = unlocked ? 'cubic-bezier(.2,.8,.2,1)' : 'cubic-bezier(.25,.8,.25,1)';

            try {
                await (M?.animate?.(bar, { width: ['0%', '' + targetPct + '%'] }, { duration, easing })?.finished);
            } catch {
                bar.style.transition = `width ${duration}s ${easing}`;
                requestAnimationFrame(() => { bar.style.width = `${targetPct}%`; });
                await new Promise(r => setTimeout(r, duration * 1000 + 20));
            }
        }

        // Force the card’s bar to 0% instantly (no animation)
        function setCardBarToZero(cardEl) {
            const wrap = cardEl?.closest?.('[data-reward-card]') || cardEl;
            const bar = wrap?.querySelector?.('[data-progress]') || null;
            if (!bar) return;

            try { bar.getAnimations?.().forEach(a => { if (a instanceof CSSAnimation) return; a.cancel(); }); } catch { }
            bar.style.transition = 'none';
            bar.style.width = '0%';
            requestAnimationFrame(() => { bar.style.transition = ''; });
        }

        function perkItemsHTML(perks = [], perk_icon = '') {
            if (!Array.isArray(perks) || !perks.length) return '';
            return perks.map(p => `
                <div class="flex items-start space-x-1 lg:space-x-2">
                ${perk_icon ? `<img src="${perk_icon}" alt="Perk" class="mt-[0.25rem] sm:mt-[0.07rem] size-3 sm:size-5 text-cyan-600 shrink-0 object-contain">` : `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="currentColor" class="mt-[0.25rem] sm:mt-[0.07rem] size-3 sm:size-5 text-cyan-600 shrink-0">
                    <path fill-rule="evenodd"
                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                    clip-rule="evenodd"></path>
                </svg>`}
                <span class="text-sm sm:text-base text-cyan-900">${p}</span>
                </div>
            `).join('');
        }

        function msgForModal(reward, compareVal, unlocked) {
            if (unlocked) return 'Unlocked!';
            const MODE = getModeAttr();
            if (MODE === 'one' || (MODE === 'subs' && getSubsMode() === 'amount')) {
                const left = Number(reward?.remain_cents || 0);
                if (left <= 0) return 'Unlocked!';
                return `${formatMoneyFromCents(left)} more to unlock`;
            }
            const left = typeof reward?.remain_items === 'number'
                ? Math.max(0, reward.remain_items)
                : Math.max(0, Number(reward.id) - Number(compareVal));
            const noun = left === 1 ? 'item' : 'items';
            return `${left} more ${noun} to unlock`;
        }

        function progressPctForModal(reward, passNow) {
            const idNum = Number(reward?.id || 0);
            if (!idNum) return 0;
            if (idNum <= passNow) return 100;
            if (idNum === passNow + 1) return clamp(pendingPctForPass(passNow), 0, 99);
            return 0;
        }

        // build only the CARD html (overlay is separate node)
        function buildModalCardHTML({ image, name, progressPct, message }) {
            return `
    <div class="bg-white shadow-md border border-neutral-200 rounded-lg overflow-hidden w-full max-w-md cart-reward-modal-z" data-lrc-reward-modal>
      <div class="w-full bg-gray-100 overflow-hidden rounded-none">
        <div class="h-4 rounded-none barber-pole-stripes" style="width:${progressPct}%; background-color:${progressPct >= 100 ? 'var(--lrc-progress-unlocked, #66cdd9)' : 'var(--lrc-progress-pending, #ffcd8f)'}"></div>
      </div>
      <div class="topography-pattern pt-2">
        <img src="${image}" alt="Reward" class="w-full h-40 sm:h-64 object-contain">
      </div>
      <div class="p-4">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-3 sm:mb-2">
          <h1 class="text-2xl font-accent text-cyan-600 leading-[1.40rem] tracking-tight" data-lrc-reward-name>${name}</h1>
          <p class="text-sm text-gray-700 pt-2" data-lrc-reward-msg>${message}</p>
        </div>
        <div class="flex flex-col space-y-1" data-lrc-reward-perks></div>
      </div>
      <button type="button" class="bg-neutral-50 text-neutral-600 lowercase py-2 text-base text-center w-full active:text-neutral-800 active:bg-neutral-100 hover:bg-neutral-100 hover:text-neutral-700" data-lrc-reward-close>
        Close
      </button>
    </div>
  `;
        }

        // holder is a fixed container to position the card;
        // overlay is a separate sibling UNDER it.
        function createModalSiblings({ image, name, progressPct, message, perks, perk_icon }) {
            // overlay (behind)
            const overlay = document.createElement('div');
            overlay.setAttribute('data-lrc-reward-overlay', '');
            overlay.setAttribute('aria-hidden', 'true');
            overlay.className = 'fixed inset-0 bg-black bg-opacity-25 z-[2000] cart-reward-modal-z';

            // holder (in front, positions card)
            const holder = document.createElement('div');
            holder.className = 'fixed inset-0 pt-4 sm:pt-20 p-4 z-[2001] flex justify-center md:justify-end items-start cart-reward-modal-z';
            holder.innerHTML = buildModalCardHTML({ image, name, progressPct, message });

            // inject perks
            const perksRoot = holder.querySelector('[data-lrc-reward-perks]');
            if (perksRoot) perksRoot.innerHTML = perkItemsHTML(perks, perk_icon);

            return { overlay, holder };
        }

        function escCloseHandler(e) {
            if (e.key === 'Escape') closeRewardModal();
        }

        // Accept an optional srcCardEl so we can animate that card on close
        async function openRewardModalById(idNum, srcCardEl) {
            const reward = REWARDS.find(r => Number(r.id) === Number(idNum));
            if (!reward) return;

            const passNow = currentPass;
            const progressPct = progressPctForModal(reward, passNow);
            const message = msgForModal(reward, passNow, Number(reward.id) <= passNow);
            const image = `${String(reward.image || '')}`;
            const name = String(reward.name || '');
            const perks = Array.isArray(reward.perks) ? reward.perks : [];
            const perk_icon = String(reward.perk_icon || '');

            if (modalOpen) closeRewardModal(true);
            lastFocused = document.activeElement;

            // keep (or set) the source card reference (in case called directly)
            modalSrcCardEl = modalSrcCardEl || srcCardEl?.querySelector('.bg-white.relative.border') || srcCardEl || null;

            const { overlay, holder } = createModalSiblings({ image, name, progressPct, message, perks, perk_icon });
            modalOverlayEl = overlay;
            modalHolderEl = holder;

            document.body.appendChild(modalOverlayEl);
            document.body.appendChild(modalHolderEl);
            lockBodyScroll(true);
            modalOpen = true;

            // original open animation
            const card = modalHolderEl.querySelector('[data-lrc-reward-modal]');
            try {
                await Promise.all([
                    M?.animate?.(modalOverlayEl, { opacity: [0, 1] }, { duration: 0.2, easing: 'ease-out' })?.finished,
                    M?.animate?.(card, { opacity: [0, 1], transform: ['rotateX(45deg)', 'rotateX(0deg)'] }, { duration: 0.4, easing: 'ease-out' })?.finished
                ]);
            } catch { }

            // focus
            const closeBtn = modalHolderEl.querySelector('[data-lrc-reward-close]');
            closeBtn?.focus?.();

            // robust, first-fire close handlers (pointerdown + click)
            const boundClose = (ev) => { try { ev.preventDefault(); ev.stopPropagation(); } catch { } closeRewardModal(); };
            closeBtn?.addEventListener('pointerdown', boundClose, { once: true });
            closeBtn?.addEventListener('click', boundClose, { once: true });
            closeBtn?.addEventListener('touchend', (ev) => { try { ev.preventDefault(); ev.stopPropagation(); } catch {} }, { once: true });
            modalOverlayEl.addEventListener('pointerdown', boundClose, { once: true });
            modalOverlayEl.addEventListener('click', boundClose, { once: true });

            // Escape
            document.addEventListener('keydown', escCloseHandler, { once: true });

            modalHolderEl.dataset.activeId = String(idNum);
        }

        async function closeRewardModal(skipAnim = false) {
            if (__closingLock) return;
            __closingLock = true;

            // Be tolerant: even if modalOpen flipped due to rerender, close if nodes exist
            const hasNodes = modalOverlayEl && modalHolderEl;
            if (!hasNodes) { __closingLock = false; return; }

            // optional tiny fade could go here if desired (skipped per your current setup)

            // Teardown DOM first so card beneath is clickable
            try {
                modalOverlayEl.remove();
                modalHolderEl.remove();
            } catch { }

            modalOverlayEl = null;
            modalHolderEl = null;
            modalOpen = false;
            lockBodyScroll(false);

            // Smoothly scale the source card down to normal (from whatever it is now)
            if (modalSrcCardEl && document.body.contains(modalSrcCardEl)) {
                try {
                    modalSrcCardEl.style.willChange = 'transform';
                    await (M?.animate?.(
                        modalSrcCardEl,
                        { transform: 'scale(1)' }, // tween from computed transform → 1
                        { duration: 0.32, easing: 'cubic-bezier(.2,.8,.2,1)' }
                    )?.finished);
                } catch { } finally {
                    modalSrcCardEl.style.willChange = '';
                    modalSrcCardEl.style.transform = '';
                }
            }

            // Now sweep its progress bar from 0% → current value
            if (modalSrcCardEl && document.body.contains(modalSrcCardEl)) {
                try { await animateCardProgressFromZero(modalSrcCardEl); } catch { }
                // Restart CSS barberPole animation which gets paused by the Web Animations API tween
                try {
                  const bar = modalSrcCardEl.querySelector('[data-progress]');
                  if (bar) {
                    bar.style.backgroundColor = '';
                    bar.classList.remove('barber-pole-stripes');
                    void bar.offsetWidth;
                    bar.classList.add('barber-pole-stripes');
                  }
                } catch { }
            }

            // cleanup + focus restore
            modalSrcCardEl = null;
            if (lastFocused && typeof lastFocused.focus === 'function') {
                try { lastFocused.focus(); } catch { }
            }

            __closingLock = false;
        }

        // live-update bar/message while open
        function refreshOpenModalIfAny() {
            if (!modalOpen || !modalHolderEl) return;
            const idNum = Number(modalHolderEl.dataset.activeId || 0);
            if (!idNum) return;

            const reward = REWARDS.find(r => Number(r.id) === idNum);
            if (!reward) return;

            const passNow = currentPass;
            const pct = progressPctForModal(reward, passNow);
            const msg = msgForModal(reward, passNow, idNum <= passNow);

            const bar = modalHolderEl.querySelector('.barber-pole-stripes');
            const msgEl = modalHolderEl.querySelector('[data-lrc-reward-msg]');
            if (bar) {
                bar.style.width = `${pct}%`;
                bar.style.backgroundColor = pct >= 100 ? '#66cdd9' : '#ffcd8f';
            }
            if (msgEl) msgEl.textContent = msg;
        }

        // Delegate clicks on See More inside the active scroller
        function wireSeeMoreDelegation() {
            const sc = getScroller();
            if (!sc) return;

            __on(sc, 'click', (e) => {
                const targetEl = (e.target instanceof HTMLElement) ? e.target : null;
                const btn = targetEl?.closest('[data-seemore]');
                if (!btn) return;

                const card = targetEl?.closest('[data-reward-card]');
                const idNum = Number(card?.getAttribute('data-id') || 0);
                if (!idNum) return;

                // source card we’ll animate
                modalSrcCardEl = card?.querySelector('.bg-white.relative.border') || card || null;

                // Immediately snap its progress bar to 0 (no await)
                if (modalSrcCardEl && document.body.contains(modalSrcCardEl)) {
                    setCardBarToZero(modalSrcCardEl);
                    // Optional: tiny lift while opening (non-blocking; modal opens immediately)
                    try {
                        M?.animate?.(
                            modalSrcCardEl,
                            { transform: ['scale(1)', 'scale(1.4)'] },
                            { duration: 0.25, easing: 'cubic-bezier(.2,.8,.2,1)' }
                        );
                    } catch { }
                }

                // Open modal right away
                openRewardModalById(idNum, card);
            });
        }

        // ================================================================
        // ========================Modal End========================================


        // Build the dynamic message per card
        function msgFor(reward, compareVal, unlocked) {
            if (unlocked) return 'Unlocked!';
            const MODE = getModeAttr();
            if (MODE === 'one' || (MODE === 'subs' && getSubsMode() === 'amount')) {
                const left = Number(reward?.remain_cents || 0);
                if (left <= 0) return 'Unlocked!';
                return `${formatMoneyFromCents(left)} more to unlock`;
            }
            // subs qty-based:
            const itemsLeft = typeof reward?.remain_items === 'number'
                ? Math.max(0, reward.remain_items)
                : Math.max(0, Number(reward.id) - Number(compareVal));
            const noun = itemsLeft === 1 ? 'item' : 'items';
            return `${itemsLeft} more ${noun} to unlock`;
        }

        // Pending progress:
        function pendingPctForPass(pass) {
            const nxt = pass + 1;
            const r = REWARDS.find(x => Number(x.id) === nxt);
            if (!r) return 0;
            const MODE = getModeAttr();

            if (MODE === 'one') {
                const subtotalCents = getAttrInt('data-lrc-one-subtotal');
                const remainCents = Number(r.remain_cents || 0);
                const targetCents = subtotalCents + remainCents;
                if (targetCents <= 0) return 0;
                return clamp(Math.round((subtotalCents / targetCents) * 100), 0, 99);
            }

            if (MODE === 'subs') {
                if (getSubsMode() === 'amount') {
                    const subtotalCents = getSubsSubtotalCents();
                    const remainCents = Number(r.remain_cents || 0);
                    const targetCents = subtotalCents + remainCents;
                    if (targetCents <= 0) return 0;
                    return clamp(Math.round((subtotalCents / targetCents) * 100), 0, 99);
                } else {
                    // quantity-based: Liquid already put % in r.progress
                    return clamp(Number(r.progress || 0), 0, 99);
                }
            }

            return 0;
        }


        function buildCard(reward, { state = 'PENDING', compareVal = 0, pendingPct = 0 } = {}) {
            const wrap = document.createElement('div');
            wrap.className = 'flex-shrink-0 snap-center overflow-visible relative h-full';
            wrap.dataset.rewardCard = '';
            wrap.dataset.id = reward.id;
            wrap.style.width = `calc(100% - ${PEEK}px)`;
            wrap.style.marginLeft = `${GAP}px`;

            const isPending = state === 'PENDING';
            const widthPct = isPending ? clamp(pendingPct, 0, 99) : 100;

            wrap.innerHTML = `
        <div class="absolute z-20 -left-2 -top-2 rounded-full size-8 flex items-center justify-center bg-tan-200 shadow shadow-tan-700" style="opacity:${isPending ? 1 : 0}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4 text-tan-700"><path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd"/></svg>
        </div>
        <div class="bg-white relative border shadow-md border-neutral-200 overflow-hidden rounded-lg">
          <div class="relative flex h-[8.5rem]">
            <div class="relative h-full flex-shrink-0 w-1/3 sm:w-[40%] mr-2 z-10 bg-white overflow-hidden rounded-l-lg topography-pattern">
              <img src="${reward.image}" alt="Reward" class="w-full h-full object-contain rounded-l-lg"/>
            </div>
            <div class="flex flex-col flex-grow z-10 bg-white overflow-hidden rounded-br-lg">
              <div class="pr-3 md:pr-4 pt-2 md:pt-3">
                <div class="w-full bg-gray-100 overflow-hidden rounded-full">
                  <div class="h-3 rounded-full barber-pole-stripes" data-progress style="width:${widthPct}%; background-color:${isPending ? 'var(--lrc-progress-pending, #ffcd8f)' : 'var(--lrc-progress-unlocked, #66cdd9)'}"></div>
                </div>
              </div>
              <h4 class="pr-3 md:pr-4 pt-2 font-accent text-cyan-600 text-[1.15rem] leading-[1.40rem] tracking-tight overflow-hidden">${reward.name}</h4>
              <p class="mt-auto py-1 pr-3 md:pr-4 font-base text-sm text-neutral-600" data-msg>${msgFor(reward, compareVal, !isPending)}</p>
              <button type="button" data-seemore class="seemore border-t border-gray-100 transition-all text-center py-2 text-xs font-semibold text-cyan-700 hover:bg-cyan-600 hover:text-white">See More</button>
            </div>
          </div>
        </div>
      `;
            wrap.dataset.state = state;
            return wrap;
        }

        function enter(el, { from = -30 } = {}) {
            el.style.opacity = '0'; el.style.transform = `translateX(${from}px)`;
            M?.animate?.(el, { opacity: [0, 1], transform: [`translateX(${from}px)`, 'translateX(0px)'] }, { duration: 0.35, easing: 'ease-out' });
        }
        function exit(el, { to = 30 } = {}) {
            return M?.animate?.(el, { opacity: [1, 0], transform: ['translateX(0px)', `translateX(${to}px)`] }, { duration: 0.25, easing: 'ease-in' })?.finished;
        }

        async function flipFromTo(el, firstRect) {
            const last = el.getBoundingClientRect();
            const dx = firstRect.left - last.left;
            const dy = firstRect.top - last.top;
            if (!dx && !dy) return;
            el.style.transform = `translate(${dx}px, ${dy}px)`;
            el.style.willChange = 'transform';
            await M?.animate?.(el, { transform: [`translate(${dx}px, ${dy}px)`, 'translate(0,0)'] }, { duration: 0.45, easing: 'ease-out' })?.finished?.catch?.(() => { });
            el.style.transform = ''; el.style.willChange = '';
        }

        function computeDesired(pass) {
            const unlockedIds = []; for (let i = pass; i >= 1; i--) unlockedIds.push(i);
            const nextPending = pass < MAX_PASS ? pass + 1 : MAX_PASS + 1;
            const desiredIds = []; if (nextPending <= MAX_PASS) desiredIds.push(nextPending); desiredIds.push(...unlockedIds);
            return { unlockedIds, nextPending, desiredIds };
        }

        function ensureAutoPendingFill(pass) { pendingFill = pendingPctForPass(pass); }

        function renderInitialFromState() {
            applyVisibility();
            const SC = getScroller(); if (!SC) return;
            ensureAutoPendingFill(currentPass);
            const { desiredIds, nextPending } = computeDesired(currentPass);
            SC.innerHTML = '';
            desiredIds.forEach((id) => {
                const r = REWARDS.find(x => Number(x.id) === id);
                const isPending = id === nextPending;
                const el = buildCard(r, { state: isPending ? 'PENDING' : 'UNLOCKED', compareVal: currentPass, pendingPct: isPending ? pendingFill : 0 });
                SC.appendChild(el);
                enter(el, { from: isPending ? -30 : 30 });
            });
            pendingId = nextPending;
            SC.scrollTo({ left: 0, behavior: 'auto' });
            updateArrows();
        }

        async function renderToPassNoCelebrate(targetPass) {
            applyVisibility();
            const SC = getScroller(); if (!SC) return;
            ensureAutoPendingFill(targetPass);
            const { desiredIds, nextPending } = computeDesired(targetPass);

            const currentNodes = new Map([...(SC.querySelectorAll('[data-reward-card]') || [])].map(el => [Number(el.dataset.id), el]));
            const reuse = new Map(); const firstRects = new Map();

            desiredIds.forEach((id) => { const el = currentNodes.get(id); if (el) { reuse.set(id, el); firstRects.set(id, el.getBoundingClientRect()); } });

            const exits = []; currentNodes.forEach((el, id) => { if (!desiredIds.includes(id)) exits.push(el); });
            await Promise.all(exits.map(el => exit(el, { to: 30 }).then(() => el.remove()))).catch(() => { });

            const frag = document.createDocumentFragment();
            desiredIds.forEach((id) => {
                const data = REWARDS.find(r => Number(r.id) === id);
                const isPending = id === nextPending;
                const el = reuse.get(id) || buildCard(data, { state: isPending ? 'PENDING' : 'UNLOCKED', compareVal: targetPass, pendingPct: isPending ? pendingFill : 0 });

                if (reuse.get(id)) {
                    el.dataset.state = isPending ? 'PENDING' : 'UNLOCKED';
                    const lock = el.querySelector('.-left-2'); if (lock) lock.style.opacity = isPending ? '1' : '0';
                    const fill = el.querySelector('[data-progress]');
                    if (fill) { if (isPending) { fill.style.width = clamp(pendingFill, 0, 99) + '%'; fill.style.backgroundColor = '#ffcd8f'; } else { fill.style.width = '100%'; fill.style.backgroundColor = '#66cdd9'; } }
                    const m = el.querySelector('[data-msg]'); if (m) m.textContent = isPending ? msgFor(data, targetPass, false) : 'Unlocked!';
                } else {
                    enter(el, { from: isPending ? -30 : 30 });
                }
                frag.appendChild(el);
            });

            SC.innerHTML = ''; SC.appendChild(frag);

            await Promise.all(desiredIds.map(async (id) => { const el = reuse.get(id), fr = firstRects.get(id); if (el && fr) await flipFromTo(el, fr); })).catch(() => { });

            currentPass = targetPass;
            const MODE = getModeAttr();
            RewardStore.setLastSeen(MODE, currentPass);

            pendingId = currentPass < MAX_PASS ? currentPass + 1 : MAX_PASS + 1;
            SC.scrollTo({ left: 0, behavior: 'smooth' });
            updateArrows();
        }

        async function celebrate(cardEl) {
            const fill = cardEl.querySelector('[data-progress]');
            const lock = cardEl.querySelector('.-left-2');
            const box = cardEl.querySelector('.bg-white.relative.border');

            const startW = parseFloat(fill?.style?.width || '0') || 0;
            await M?.animate?.(fill, { width: [startW + '%', '100%'], backgroundColor: ['#ffcd8f', '#66cdd9'] }, { duration: 0.8, easing: 'ease-out' })?.finished;
            await M?.animate?.(box, { rotate: [0, 2.5, 0, -2.5, 0, 2.5, 0, -2.5, 0] }, { duration: 0.3, easing: 'ease-in-out' })?.finished;

            await Promise.all([
                M?.animate?.(box, { transform: ['scale(1)', 'scale(1.1)'] }, { duration: 0.25, easing: 'ease-out' })?.finished,
                (async () => {
                    await wait(50);
                    const r = box.getBoundingClientRect();
                    // emoji blast removed for performance
                })(),
            ]);
            await M?.animate?.(box, { transform: ['scale(1.1)', 'scale(1)'] }, { duration: 0.25, easing: 'ease-in' })?.finished;
            if (lock) M?.animate?.(lock, { opacity: [1, 0] }, { duration: 0.2 });
        }

        // ----- tiny helpers for event payloads -----
        function rewardById(id) {
            return REWARDS.find(r => Number(r.id) === Number(id)) || {};
        }
        function buildDetailForPass(pass, mode) {
            const r = rewardById(pass);
            return {
                mode,
                pass,
                gift_items: Array.isArray(r.gift_items) ? r.gift_items : [],
                gift_variant_ids: Array.isArray(r.gift_variant_ids) ? r.gift_variant_ids : [],
                discount_number: Number(r.discount_number || 0),
                reward_type: r?.reward_type || null,
                subs_selling_plan_name: String(r?.subs_selling_plan_name || '').trim(),
                reward: r
            };
        }

        async function unlockOneStep() {
            const SC = getScroller(); if (!SC) return;
            if (currentPass >= MAX_PASS) return;

            ensureAutoPendingFill(currentPass);
            const currentPending = currentPass + 1;
            const card = SC.querySelector(`[data-reward-card][data-id="${currentPending}"]`);
            if (!card) return;

            const MODE = getModeAttr();
            const detail = buildDetailForPass(currentPending, MODE);

            // >>> FIRE "unlocked" IMMEDIATELY (BEFORE celebration)
            emit(ROOT, 'lrc:reward-unlocked', detail);

            // Visual celebration (runs after event)
            const fill = card.querySelector('[data-progress]');
            if (fill) fill.style.width = clamp(pendingFill, 0, 99) + '%';
            await celebrate(card);

            // Mark UI as unlocked
            const msgEl = card.querySelector('[data-msg]'); if (msgEl) msgEl.textContent = 'Unlocked!';
            const lock = card.querySelector('.-left-2'); if (lock) lock.style.opacity = '0';

            // Persist state
            RewardStore.setMax(MODE, currentPass + 1);
            RewardStore.setLastSeen(MODE, currentPass + 1);

            // Prepare next pending if any
            if (currentPending < MAX_PASS) {
                const firstRect = card.getBoundingClientRect();
                const nextPendingId = currentPending + 1;
                const nextR = REWARDS.find(r => Number(r.id) === nextPendingId);
                const nextPass = currentPass + 1;
                const nextAutoPct = pendingPctForPass(nextPass);

                const newPending = buildCard(nextR, { state: 'PENDING', compareVal: nextPass, pendingPct: nextAutoPct });
                SC.insertBefore(newPending, SC.firstChild);
                enter(newPending, { from: -30 });
                await flipFromTo(card, firstRect);
                SC.scrollTo({ left: 0, behavior: 'smooth' });
                pendingFill = nextAutoPct;
            } else {
                pendingFill = 0;
            }

            currentPass += 1;
            pendingId = currentPass < MAX_PASS ? currentPass + 1 : MAX_PASS + 1;
            await renderToPassNoCelebrate(currentPass);
            refreshOpenModalIfAny();
            updateArrows();
        }

        // --- public controls ---
        async function setPass(targetPass, { animate = 'forward' } = {}) {
            targetPass = clamp(targetPass, 0, MAX_PASS);
            const MODE = getModeAttr();
            const curMax = RewardStore.getMax(MODE);
            if (targetPass < curMax) RewardStore.lowerTo(MODE, targetPass);

            // Immediate "locking" emits BEFORE any await when decreasing
            if (targetPass < currentPass) {
                for (let i = currentPass; i > targetPass; i--) {
                    emit(ROOT, 'lrc:reward-locking', buildDetailForPass(i, MODE));
                }
            }

            if (animate === 'forward' && targetPass > currentPass) {
                if (isRunning) return;
                isRunning = true;
                try {
                    // (Keep optional pre-event if you still use it; safe to leave or remove)
                    // for (let i = currentPass + 1; i <= targetPass; i++) {
                    //   emit(ROOT, 'lrc:reward-unlocking', buildDetailForPass(i, MODE));
                    // }

                    // then do visuals
                    renderInitialFromState();
                    await twoFrames();
                    while (currentPass < targetPass) {
                        await unlockOneStep(); // "lrc:reward-unlocked" now fires at the TOP of this function
                        refreshOpenModalIfAny();
                    }
                } finally { isRunning = false; }
            } else {
                const prevPass = currentPass;
                await renderToPassNoCelebrate(targetPass);
                refreshOpenModalIfAny();

                // Post "locked" events after render to mirror UI
                if (targetPass < prevPass) {
                    for (let i = prevPass; i > targetPass; i--) {
                        emit(ROOT, 'lrc:reward-locked', buildDetailForPass(i, MODE));
                    }
                }
            }
        }

        function setQty(q, opts) { return setPass(clamp(Number(q) || 0, 0, MAX_PASS), opts); }

        // arrow listeners (always act on the CURRENT visible lane)
        function maxScrollLeft(sc) { return Math.max(0, sc.scrollWidth - sc.clientWidth); }

        __on(LEFT_BTN, 'click', () => {
            const SC = getScroller(); if (!SC) return;
            const next = Math.max(0, SC.scrollLeft - pageDelta());
            SC.scrollTo({ left: next, behavior: 'smooth' });
            updateArrows();
        });

        __on(RIGHT_BTN, 'click', () => {
            const SC = getScroller(); if (!SC) return;
            const next = Math.min(maxScrollLeft(SC), SC.scrollLeft + pageDelta());
            SC.scrollTo({ left: next, behavior: 'smooth' });
            updateArrows();
        });

        // keep arrow states fresh while scrolling either lane
        __on(SCROLLERS.subs, 'scroll', updateArrows, { passive: true });
        __on(SCROLLERS.one, 'scroll', updateArrows, { passive: true });

        // initial render
        applyVisibility();
        renderInitialFromState();
        wireSeeMoreDelegation();

        return {
            root: ROOT,
            setPass,
            setQty,
            refreshFromDom() {
                try {
                    const raw = ROOT.getAttribute('data-lrc-rewards') || '[]';
                    const decoded = (() => { const t = document.createElement('textarea'); t.innerHTML = raw; return t.value; })();
                    const parsed = JSON.parse(decoded);
                    REWARDS = Array.isArray(parsed) ? parsed : [];
                } catch { REWARDS = []; }
                MAX_PASS = REWARDS.length;
                currentPass = clamp(currentPass, 0, MAX_PASS);
                applyVisibility();
                renderInitialFromState();
                return MAX_PASS;
            },
            destroy() {
                try { __listeners.forEach(function (L) { L.target.removeEventListener(L.event, L.handler, L.opts); }); } catch (e) {}
                __listeners.length = 0;
            }
        };
    };

    // ---------------- Manager (mount / reuse across drawer updates) ----------------
    (function Manager() {
        window.__lrcRewardsPass = typeof window.__lrcRewardsPass === 'number' ? window.__lrcRewardsPass : 0;
        window.__lrcRewardsMode = typeof window.__lrcRewardsMode === 'string' ? window.__lrcRewardsMode : null;

        let mountLock = false;

        const getInt = (root, name) => parseInt(root.getAttribute(name) || '0', 10) || 0;
        const getMode = (root) => (root?.getAttribute('data-lrc-mode') || 'subs');

        function safeLenFromAttr(root) {
            try {
                const raw = root.getAttribute('data-lrc-rewards') || '[]';
                const decoded = (() => { const t = document.createElement('textarea'); t.innerHTML = raw; return t.value; })();
                const arr = JSON.parse(decoded);
                return Array.isArray(arr) ? arr.length : 0;
            } catch { return 0; }
        }

        function parseThresholdsCsv(csv) {
            if (!csv) return [];
            return csv.split(',')
                .map(s => parseInt(String(s).trim(), 10))
                .filter(n => Number.isFinite(n) && n >= 0)
                .sort((a, b) => a - b);
        }

        function parseOneConfig(root) {
            try {
                const raw = root.getAttribute('data-lrc-one-config') || '[]';
                const txt = (() => { const t = document.createElement('textarea'); t.innerHTML = raw; return t.value; })();
                const arr = JSON.parse(txt);
                return Array.isArray(arr) ? arr : [];
            } catch { return []; }
        }

        // Background sync for a hidden one-time stream (subs visible)
        function backgroundSyncHiddenOne(root) {
            const subQty = parseInt(root.getAttribute('data-lrc-subqty') || '0', 10) || 0;
            const oneCents = parseInt(root.getAttribute('data-lrc-one-subtotal') || '0', 10) || 0;

            if (subQty <= 0) return;

            const oneConfig = parseOneConfig(root);
            const thresholdsCsv = root.getAttribute('data-lrc-one-thresholds') || '';
            const thresholds = parseThresholdsCsv(thresholdsCsv); // cents

            const prevSeen = RewardStore.getLastSeen('one');
            const prevMax = RewardStore.getMax('one');

            if (oneCents === 0) {
                if (prevSeen > 0) {
                    for (let i = prevSeen; i >= 1; i--) {
                        const cfg = oneConfig.find(x => Number(x.id) === i) || {};
                        const detail = {
                            mode: 'one',
                            pass: i,
                            gift_items: Array.isArray(cfg.gift_items) ? cfg.gift_items : [],
                            gift_variant_ids: Array.isArray(cfg.gift_variant_ids) ? cfg.gift_variant_ids : [],
                            discount_number: Number(cfg.discount_number || 0),
                            reward_type: cfg?.reward_type || null,
                            subs_selling_plan_name: String(cfg?.subs_selling_plan_name || '').trim(),
                            reward: cfg,
                            hidden: true
                        };
                        emit(root, 'lrc:reward-locking', detail);   // immediate
                        emit(root, 'lrc:reward-locked', detail);   // post
                    }
                }
                RewardStore.hardReset('one');
                return;
            }

            if (!thresholds.length) {
                RewardStore.setLastSeen('one', prevSeen);
                return;
            }

            let pass = 0;
            for (let i = 0; i < thresholds.length; i++) {
                if (oneCents >= thresholds[i]) pass++;
                else break;
            }

            if (pass > prevSeen) {
                for (let i = prevSeen + 1; i <= pass; i++) {
                    const cfg = oneConfig.find(x => Number(x.id) === i) || {};
                    const detail = {
                        mode: 'one',
                        pass: i,
                        gift_items: Array.isArray(cfg.gift_items) ? cfg.gift_items : [],
                        gift_variant_ids: Array.isArray(cfg.gift_variant_ids) ? cfg.gift_variant_ids : [],
                        discount_number: Number(cfg.discount_number || 0),
                        reward_type: cfg?.reward_type || null,
                        subs_selling_plan_name: String(cfg?.subs_selling_plan_name || '').trim(),
                        reward: cfg,
                        hidden: true
                    };
                    // No celebration in hidden lane; immediate unlock is fine here.
                    emit(root, 'lrc:reward-unlocked', detail);
                }
                RewardStore.setMax('one', Math.max(prevMax, pass));
                RewardStore.setLastSeen('one', pass);
            } else if (pass < prevSeen) {
                for (let i = prevSeen; i > pass; i--) {
                    const cfg = oneConfig.find(x => Number(x.id) === i) || {};
                    const detail = {
                        mode: 'one',
                        pass: i,
                        gift_items: Array.isArray(cfg.gift_items) ? cfg.gift_items : [],
                        discount_number: Number(cfg.discount_number || 0),
                        reward_type: cfg?.reward_type || null,
                        subs_selling_plan_name: String(cfg?.subs_selling_plan_name || '').trim(),
                        reward: cfg,
                        hidden: true
                    };
                    emit(root, 'lrc:reward-locking', detail);  // immediate
                    emit(root, 'lrc:reward-locked', detail);   // post
                }
                RewardStore.lowerTo('one', pass);
            } else {
                RewardStore.setLastSeen('one', pass);
            }
        }

        async function mountRewards() {
            if (mountLock) return;
            mountLock = true;
            try {
                const root = document.getElementById('lrc-rewards-root');

                if (!root) {
                    try { window.LRC_Rewards?.destroy?.(); } catch { }
                    window.LRC_Rewards = null;
                    RewardStore.hardResetAll();
                    return;
                }

                const mode = getMode(root);
                const modeChanged = !!(window.__lrcRewardsMode && window.__lrcRewardsMode !== mode);

                const lenGuess = safeLenFromAttr(root) || 8;
                let nextPassAttr = Math.max(0, Math.min(Number(root.getAttribute('data-lrc-qty')) || 0, lenGuess));

                // live counters
                const subQtyAttr = getInt(root, 'data-lrc-subqty');
                const oneSubtotalCents = getInt(root, 'data-lrc-one-subtotal');

                if (subQtyAttr === 0) RewardStore.hardReset('subs');
                if (oneSubtotalCents === 0) RewardStore.hardReset('one');

                backgroundSyncHiddenOne(root);

                if (mode === 'subs' && subQtyAttr === 0) nextPassAttr = 0;
                if (mode === 'one' && oneSubtotalCents === 0) nextPassAttr = 0;

                if (modeChanged) {
                    try { window.LRC_Rewards?.destroy?.(); } catch { }
                    window.LRC_Rewards = null;

                    const baseline = RewardStore.getMax(mode);
                    const inst = window.LRC_createRewards(root, { baselinePass: baseline });
                    window.LRC_Rewards = inst;

                    await twoFrames();
                    await inst.setPass(nextPassAttr, { animate: nextPassAttr > baseline ? 'forward' : 'none' });

                    window.__lrcRewardsPass = nextPassAttr;
                    window.__lrcRewardsMode = mode;
                    return;
                }

                if (window.LRC_Rewards && window.LRC_Rewards.root === root) {
                    const max = window.LRC_Rewards.refreshFromDom();
                    let nextPass = Math.max(0, Math.min(Number(root.getAttribute('data-lrc-qty')) || 0, max || 0));
                    if (mode === 'subs' && subQtyAttr === 0) nextPass = 0;
                    if (mode === 'one' && oneSubtotalCents === 0) nextPass = 0;

                    const storedMax = RewardStore.getMax(mode);
                    if (nextPass < storedMax) RewardStore.lowerTo(mode, nextPass);
                    if (nextPass === 0) RewardStore.hardReset(mode);

                    const base = RewardStore.getMax(mode);

                    await twoFrames();
                    await window.LRC_Rewards.setPass(base, { animate: 'none' });
                    await window.LRC_Rewards.setPass(nextPass, { animate: nextPass > base ? 'forward' : 'none' });

                    window.__lrcRewardsPass = nextPass;
                    window.__lrcRewardsMode = mode;
                    return;
                }

                // Fresh mount
                const baseline = RewardStore.getMax(mode);
                try { window.LRC_Rewards?.destroy?.(); } catch { }
                const inst = window.LRC_createRewards(root, { baselinePass: baseline });
                window.LRC_Rewards = inst;

                if (nextPassAttr === 0) RewardStore.hardReset(mode);

                await twoFrames();
                const animateForward = nextPassAttr > baseline;
                await inst.setPass(nextPassAttr, { animate: animateForward ? 'forward' : 'none' });

                window.__lrcRewardsPass = nextPassAttr;
                window.__lrcRewardsMode = mode;
            } finally {
                mountLock = false;
            }
        }

        window.addEventListener('DOMContentLoaded', mountRewards);
        document.addEventListener('lrc:drawer-updated', mountRewards);
    })();

})();

document.addEventListener('lrc:reward-unlocked', (e) => {
    const { mode, pass, gift_items, discount_number, reward } = e.detail;
    console.log('[Rewards] Unlocked', { mode, pass, gift_items, discount_number, reward });
});

document.addEventListener('lrc:reward-locked', (e) => {
    const { mode, pass, gift_items, discount_number, reward } = e.detail;
    console.log('[Rewards] Relocked', { mode, pass, gift_items, discount_number });
});


// ===================


